<!---评论列表--->
<template>
<div class="comment-warrp" v-if="pageInit" ref="comment-warrp">
    <div class="comment-head">
        <h3 class="comment-title">
            用户评价 {{listCount}}
        </h3>
        <div class="comment-sort">
            <el-select v-model="sort" placeholder="请选择" size="small" @change="sortChange">
                <el-option label="智能排序" :value="1"></el-option>
                <el-option label="最新评论" :value="2"></el-option>
            </el-select>
        </div>
    </div>
    <ul class="comment-list" ref="comment-list">
        <li v-for="(item,index) in list" :key="item.id">
            <div class="comment-user">
                <div class="comment-user-ig">
                    <YorkbbsImage
                    class="info-cover"
                    animation
                    fit="contain"
                    target="_blank"
                    :src="item.user.avatar | webpFormat(36)"
                    :link="detailURL(item)"
                    
                    ></YorkbbsImage>
                </div>
                <div class="comment-user-info">
                    <div class="comment-user-home"><a :href="detailURL(item)" target="_blank">{{item.user.username}}</a></div>
                    <div class="comment-start">
                        <div class="start" v-for="starat in 5" :key="starat" :class="{active:item.property.view >= starat}"></div>

                    </div>
                </div>
                <div class="comment-time">{{item.createdAt|timeFormat('y-m-d')}}</div>
            </div>
            <div class="comment-content">
                <div class="comment-html  J-html" v-html="item.content"  :class="{'limit-line':item.moreLine && (item.isShowMore == false)}"></div>
                <div class="more-line" v-if="item.moreLine">
                    <div @click="showMoreHandler(true,index)" v-if="item.isShowMore == false">查看更多 <span class="yk-news_down"></span></div>
                    <div @click="showMoreHandler(false,index)" v-if="item.isShowMore">收起 <span class="yk-news_up"></span></div>
                </div>
            </div>
            <div class="comment-img" v-if="item.imageList.length>0">
                <div class="ig" v-for="(img,index) in item.imageList" :key="img+'_'+index">
                    <YorkbbsImage
                        class="front-images"
                        :src="img | webpFormat(300)"
                        :preview-src-list="imageList"
                    >
                        <!-- <button class="front-button__images">
                        <i class="yk-picture"></i>
                        <span>{{ item.imageList.length }}</span>
                        </button> -->
                    </YorkbbsImage>
                </div>
            </div>
            <div class="comment-replay" v-if="item.children.items.length>0">
                <div class="comment-user">
                    <div class="comment-user-ig">
                        <YorkbbsImage
                        class="info-cover"
                        animation
                        fit="contain"
                        target="_blank"
                        :src="item.children.items[0].user.avatar | webpFormat(36)"
                        :link="detailURL(item.children.items[0])"
                        
                        ></YorkbbsImage>
                    </div>
                    <div class="comment-user-info">
                        <div class="comment-user-home"><a :href="detailURL(item.children.items[0])" target="_blank">{{item.children.items[0].user.username}}</a></div>    
                        <div class="merchants-tag" v-if="isMerchartsReplay(item.children.items[0])">商家</div>
                    </div>
                    <div class="comment-time">{{item.children.items[0].createdAt|timeFormat('y-m-d')}}</div>
                </div>
                <div class="comment-content">
                    <div class="comment-html" v-html="item.children.items[0].content"></div>
                </div>
            </div>
        </li>
        <li class="no-data" v-if="list.length == 0 && postLoading == false">
            <img :src="require('@/assets/images/common/no-data.png')" alt="">
            <div class="txt">该商家暂无评价</div>
        </li>
    </ul>
    <div class="comment-load-more" @click="loadMore" v-if="hasMore" v-loading="postLoading">查看更多评价 <span class="yk-news_down"></span></div>
</div>
</template>
<script>
import {hostBuild } from '@/utils/utils'
export default {
    name:'CommentList',
    props:{
        post:{
            type:Object,
            default:{}
        }
    },
    data(){
        return {
            pageInit:false,
            sort:1,
            params:{
                "offset": 1,
                "size": 10,
                "sort": ["property_good:DESC","createdAt:DESC"],
                "postId": ""
            },
            list:[],
            listCount:0,
            hasMore:false,
            postLoading:false,
            warrpWidth:784,
        }
    },
    
    created(){
        //abd6dffc-243b-48ac-90d6-b9d24cebe38f
        this.params.postId = this.post.id;
        this.getCommentList();
       
    },
  
    methods:{
       
        isMerchartsReplay(comment){
            return this.post.user.id == comment.user.id;
        },
        detailURL(data) {
            return hostBuild(`/home/${data.user.id}`, 'home');
      
        },
        sortChange(val){
            if(val == 1 ){
                this.params.sort =  ["property_good:DESC", "createdAt:DESC"];
            }else{
                this.params.sort = ["createdAt:DESC"]
            }
            this.params.offset = 1;
            this.list = [];
            this.hasMore = true;
            this.getCommentList();
        },
        async getCommentList(){
            this.postLoading = true;
            
            let result = await this.$axios.post('/info/v1/get/comment/list',this.params)
            this.postLoading = false;
            this.pageInit = true;
            
            this.list = this.list.concat(result.data.items.map(item=>{
                item.moreLine = false;
                item.isShowMore = false;
                return item;
            }));
            this.listCount = result.data.itemTotal;
            this.hasMore = result.data.items.length ==  this.params.size;
            this.$nextTick(()=>{
                
                var liList = this.$refs['comment-list'].getElementsByTagName('li');
                let start = (this.params.offset-1)*this.params.size;
                let end = this.params.offset* this.params.size;
                if( end > this.list.length){
                    end = this.list.length;
                }
                for(var i=start; i<end; i++){
                    let height = liList[i].getElementsByClassName('J-html')[0].scrollHeight;
                    
                    if( height > 48 ){
                        this.list[i].moreLine = true;
                    }
                }
            })
        },
        loadMore(){
            if( this.postLoading ) return false;
            this.params.offset+= 1;
            
            this.getCommentList();
        },
        showMoreHandler(bool,index){
            
            this.list[index].isShowMore = bool;
        }
    }
}
</script>
<style lang="scss" scoped>
.comment-warrp{
    .comment-head{
        display: flex; align-items: center;
        .comment-title{
            flex:1; display: flex; align-items: center;color: #222; font-size: 20px; line-height: 28px;font-weight: bold;

        }
        .comment-sort{width: 100px;}
    }
    .comment-list{
        list-style: none; min-height: 120px;
        li{
            padding: 25px 0; border-bottom: 1px solid #eee;
            &.no-data{
                img{display: block; margin: 0 auto 20px;}
                .txt{text-align: center; color: var(--text-color-6); font-size: 16px; line-height: 22px;}
            }   
            &:last-child{border-bottom: none;}
            .comment-user{
                display: flex; align-items: stretch; margin-bottom: 15px;
                .comment-user-ig{
                    width: 36px; height: 36px; border-radius: 50%; overflow: hidden; margin-right: 10px;
                }
                .comment-user-info{
                    flex:1; display: flex; display: flex; flex-direction: column;justify-content: space-between;
                    .comment-user-home{
                        display: flex; align-items: center;
                        a{
                            font-size: 14px; line-height: 20px; font-weight: bold;
                            &:hover{color: var(--primary-color);}
                        }
                    }
                    .comment-start{
                        display: flex; align-content: center;
                        .start{
                            background: url('~@/assets/images/info/start-gavy.png') no-repeat; width: 13px; height: 12px; margin-right: 2px;
                            &.active{background: url('~@/assets/images/info/start-red.png') no-repeat}
                        }
                    } 
                }
                .comment-time{font-size: 12px; line-height: 17px; color: var(--text-color-9);}
            }
            .comment-content{
                padding: 0 0 0 46px;position: relative;
                .comment-html{font-size: 16px; line-height: 24px; color: var(--text-color-1);
                    &.limit-line{height: 48px; overflow: hidden;}
                }
                .more-line{
                    position: absolute; right: 0; bottom: 2px;
                    div{
                        font-size: 14px; line-height: 20px; color: var(--text-color-9); cursor: pointer; background: #fff; padding: 0 0 0 15px;
                        span{font-size: 12px;}
                    }
                }
            }
            .comment-img{
                display: flex; margin: 20px -4px 0; 
                .ig{width:11.11%}
            }
            .comment-replay{
                margin: 25px 0 0 46px;
                .comment-user{
                    align-items: center; 
                    .comment-user-info{
                        flex-direction: row; justify-content: flex-start;
                        .merchants-tag{font-size: 12px; line-height: 18px; height: 18px; color: var(--primary-color); background: var(--primary-color-lightest); padding: 0 3px; margin-left: 5px;}
                    }
                }
            }
        }
    }
    .comment-load-more{
        display: flex; align-items: center; justify-content: center; height: 44px; background:#f8f8f8; color: var(--text-color-1);cursor: pointer; font-size: 16px; transition: all 200ms linear;
        span{margin-left: 5px; font-size: 12px;}
        &:hover{background: var(--primary-color-lightest); color: var(--primary-color);}
    }
}
</style>